import { debugStore } from "@folio-2026/experience/debug"
import { Provider } from "jotai"
import { PropsWithChildren } from "react"

export default function Providers({ children }: PropsWithChildren) {
  return <Provider store={debugStore}>{children}</Provider>
}
